import { EmployeeLiteModel } from 'api-hooks/employee';
import { GuestModel } from 'api-hooks/guest';
import { PreferenceTagItemModel } from 'api-hooks/preference-tag';
import { VisaDocumentLiteModel } from 'api-hooks/visa-document';
import { Expose, Type } from 'class-transformer';
import { DocumentSaleStatusEnum } from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
  ImageClass,
} from 'common/repositories/common.model';

import { CommonMutationInput, SaleLiteModel, SaleModel } from '../common';

// DON'T DELETE THIS COMMENT CODE
// export enum DocumentSaleStatusEnum {
//   processed = 'processed',
//   submitted = 'submitted',
//   finished = 'finished',
//   canceled = 'canceled',
//   pending_revert_to_processed_approval = 'pending_revert_to_processed_approval',
//   pending_revert_to_submitted_approval = 'pending_revert_to_submitted_approval',
// }

export enum ActionStatusEnum {
  SUBMIT = 'submit',
  FINISH = 'finish',
  CANCEL = 'cancel',
  REVERT_TO_SUBMITTED = 'draft-revert-to-submitted',
  REVERT_TO_PROCESSED = 'draft-revert-to-processed',
}

export enum DocumentSaleGuestDetailStatusEnum {
  Pending = 'pending',
  Completed = 'completed',
  Rejected = 'rejected',
}

export class DetailModel extends CommonModel {
  number: string;
  biometric?: boolean;
  description: string;
  nationality?: string;
  type?: string;
  gender?: string;
  company?: string;
  package?: string;

  @Expose({ name: 'document_status' })
  documentStatus?: DocumentSaleGuestDetailStatusEnum;

  @Expose({ name: 'visa_document' })
  @Type(() => VisaDocumentLiteModel)
  visaDocument?: VisaDocumentLiteModel;

  @Expose({ name: 'cover_area' })
  coverArea?: string;

  @Type(() => Number)
  days?: number;

  @Expose({ name: 'start_at' })
  @Type(() => Date)
  startAt?: Date;

  @Expose({ name: 'end_at' })
  @Type(() => Date)
  endAt?: Date;

  @Type(() => Number)
  price: number;

  @Expose({ name: 'issued_at' })
  @Type(() => Date)
  issuedAt: Date;

  @Expose({ name: 'expired_at' })
  @Type(() => Date)
  expiredAt: Date;

  @Type(() => ImageClass)
  files: ImageClass[];

  @Expose({ name: 'appointment_at' })
  @Type(() => Date)
  appointmentAt?: Date | null;

  @Expose({ name: 'document_type' })
  documentType: string;

  @Expose({ name: 'date_of_birth' })
  @Type(() => Date)
  dateOfBirth: Date;

  @Expose({ name: 'place_of_birth' })
  placeOfBirth: string;

  @Expose({ name: 'family_name' })
  familyName: string;

  @Expose({ name: 'given_name' })
  givenName: string;

  @Expose({ name: 'identifier_number' })
  identifierNumber: string;

  @Expose({ name: 'issue_state' })
  issueState: string;

  @Expose({ name: 'issue_at' })
  issueAt: string;

  // for Apec Card
  email?: string;
  name?: string;
  pin?: string;

  @Expose({ name: 'application_number' })
  applicationNumber?: string;

  @Expose({ name: 'document_number' })
  documentNumber?: string;

  @Expose({ name: 'passport_number' })
  passportNumber?: string;
}

export class DocumentSaleGuestModel extends CommonModel {
  @Type(() => DetailModel)
  details: DetailModel[] | DetailModel;

  @Type(() => Number)
  price?: number;

  @Type(() => PreferenceTagItemModel)
  preferences?: PreferenceTagItemModel[];

  @Type(() => GuestModel)
  guest: GuestModel;
}

export class DocumentSaleAddOnsModel extends CommonModel {
  description: string;

  @Type(() => Number)
  price: number;

  @Type(() => GuestModel)
  guest: GuestModel;
}

export class DocumentSaleModel extends CommonModel {
  reminder: boolean;

  @Expose({ name: 'reminder_date' })
  @Type(() => Date)
  reminderDate: Date | null;

  @Expose({ name: 'reminder_description' })
  reminderDescription: string | null;

  @Expose({ name: 'visa_documents' })
  @Type(() => VisaDocumentLiteModel)
  visaDocuments?: VisaDocumentLiteModel[];

  @Expose({ name: 'document_receive_date' })
  @Type(() => Date)
  documentReceiveDate: Date | null;

  @Expose({ name: 'document_type' })
  documentType: string;

  @Expose({ name: 'document_sale_add_ons' })
  @Type(() => DocumentSaleAddOnsModel)
  documentSaleAddOns: DocumentSaleAddOnsModel[];

  @Expose({ name: 'document_sale_guests' })
  @Type(() => DocumentSaleGuestModel)
  documentSaleGuests: DocumentSaleGuestModel[];

  @Expose({ name: 'completion_date_estimation' })
  @Type(() => Date)
  completionDateEstimation: Date;
}

export class PurchaseModel {
  id: string;
  number: string;

  @Type(() => Number)
  total: number;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;
}
export class TravelDocumentSalesModel extends SaleModel {
  @Expose({ name: 'document_sale_status' })
  documentSaleStatus: DocumentSaleStatusEnum;

  @Expose({ name: 'document_sales' })
  @Type(() => DocumentSaleModel)
  documentSales: DocumentSaleModel[];

  @Expose({ name: 'document_admin' })
  @Type(() => EmployeeLiteModel)
  documentAdmin: EmployeeLiteModel | null;
}

export class TravelDocumentSalesLiteModel extends SaleLiteModel {}
//query
export class getTravelDocumentsSalesInput {
  params: CommonParamInput & {
    status?: string;
    selection?: string;
  };
}

export class getTravelDocumentSalesInput {
  id: string;
}

//mutation
export class TravelDocumentSalesDocumentSaleGuestDetailMutationInput {
  //general
  id?: string;
  description: string;
  price: number;
  //apec, insurance, passport
  type?: string;
  //insurance
  startAt?: Date | null;
  endAt?: Date | null;
  days?: number;
  package?: string;
  company?: string;
  coverArea?: string;
  //visa
  appointmentAt?: Date | null;
  biometric: boolean;
}
export class TravelDocumentSalesDocumentSaleGuestMutationInput {
  preferences: string[];
  guestId: string;
  details: TravelDocumentSalesDocumentSaleGuestDetailMutationInput[];
}

export class TravelDocumentSalesDocumentSaleAddOnsMutationInput {
  id?: string;
  price: number;
  description: string;
  guestId: string;
}

export class TravelDocumentSalesDocumentSaleMutationInput {
  reminder: boolean;
  reminderDate: Date | null | undefined;
  reminderDescription: string | null;
  documentType: string;
  documentReceiveDate: Date | null | undefined;
  visaDocuments: string[];
  documentSaleGuests: TravelDocumentSalesDocumentSaleGuestMutationInput[];
  documentSaleAddOns: TravelDocumentSalesDocumentSaleAddOnsMutationInput[];
}

export class TravelDocumentSalesMutationInput extends CommonMutationInput {
  documentSales: TravelDocumentSalesDocumentSaleMutationInput[];
}

export class TravelDocumentSalesMutationUpdateInput {
  id: string;
  body: TravelDocumentSalesMutationInput;
}

export class TravelDocumentSalesStatusMutationUpdateInput {
  id: string;
  body: {
    action: string;
    completionDateEstimation?: Date | null;
  };
}

export class TravelDocumentSalesMutationVoidInput {
  id: string;
}

//document
export class UploadTravelDocumentSalesMutationInput {
  documentSales: {
    id: string;
    documentSaleGuests: {
      documentSaleGuestDetails: {
        documentStatus: string;
        number: string;
        issuedAt: string;
        expiredAt: string;
        files: { id: string; image: string }[];

        //passport
        type?: string | null;
        // number?: string | null;
        identifierNumber?: string | null;
        familyName?: string | null;
        givenName?: string;
        issueState?: string;
        placeOfBirth?: string;
        nationality?: string;
        gender?: string | null;
        dateOfBirth?: Date | null;
        // expiredAt?: Date | null;

        // for Apec Card
        email?: string;
        name?: string;
        pin?: string;
        applicationNumber?: string;
        documentNumber?: string;
        passportNumber?: string;
      }[];
      id: string;
    };
  }[];
}
export class UploadTravelDocumentSalesMutationUpdate {
  id: string;
  body: UploadTravelDocumentSalesMutationInput;
}

export class CompleteTravelDocumentSalesMutation {
  id: string;
}

export class RevertCompleteTravelDocumentSalesMutation {
  id: string;
}
